import { PermissionsConstrains } from "@/enums/permissions.enum";
import { CurrencyInterface } from "@/interface/business/currency.interface";
import { CurrencyType } from "@/types/business/currency.type";

export class Currency implements CurrencyInterface {
  id: string = "";
  code: string = "";
  name: string = "";

  public static MODULE = PermissionsConstrains.BUSINESS_CURRENCY;

  constructor(data: CurrencyType) {
    if (data) {
      this.id = data.id || "";
      this.code = data.code || "";
      this.name = data.name || "";
    }
  }
}
